import Container from 'react-bootstrap/Container';
import {Nav, Navbar} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';


const header =() => {
  return (
    <Navbar bg="dark" variant="dark" expand="lg">
      <Container>
        <LinkContainer to="/">
            <Navbar.Brand>Portfolio-Webseite-Adrian-Dröse</Navbar.Brand>
        </LinkContainer>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <LinkContainer to="/projects">
                <Nav.Link>JavaScript Projekte</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/about">
              <Nav.Link>Bachelorarbeit</Nav.Link>
            </LinkContainer>
            <LinkContainer to="/contact">
                <Nav.Link>Kontakt</Nav.Link>
            </LinkContainer>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default header;